import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { aweTheme } from 'themes/variables';

import LandingPage from 'containers/LandingPage/Loadable';
import EarlyBird from 'containers/EarlyBird/Loadable';
import ThankYou from 'containers/ThankYou/Loadable';
import RequestErrorPage from 'containers/RequestErrorPage/Loadable';
import CookieDeclaration from 'containers/CookieDeclaration/Loadable';
import VisaPage from 'containers/VisaPage/Loadable';
import Hotel from 'containers/Hotel';
import GlobalStyle from 'themes/global';
import moment from 'moment';

import { getEarlyBird } from '../../common/helpers';

const earlyBirdEnd = getEarlyBird();

function App() {
  return (
    <ThemeProvider theme={aweTheme}>
      <main className="app">
        <Switch>
          <Route exact path="/" component={earlyBirdEnd.isAfter(moment()) ? EarlyBird : LandingPage} />
          <Route exact path="/professorofamazon" component={LandingPage} />
          <Route exact path="/globalfromasia" component={LandingPage} />
          <Route exact path="/fba4u" component={LandingPage} />
          <Route exact path="/milliondollarsellers" component={LandingPage} />
          <Route exact path="/early-bird" component={EarlyBird} />
          <Route exact path="/thank-you" component={ThankYou} />
          <Route exact path="/cookie-declaration" component={CookieDeclaration} />
          <Route exact path="/request-a-visa-letter" component={VisaPage} />
          <Route exact path="/hotel" component={Hotel} />
          <Route exact path="/405" component={RequestErrorPage} />
          <Redirect to="/not-found" />
        </Switch>
        <GlobalStyle />
      </main>
    </ThemeProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js